var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view == 1)?_c('roles'):_c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v("Información básica del rol")]),_c('modalRol',{attrs:{"action":"update"}}),_c('hr'),_c('permissions',{attrs:{"type":"admin"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }